export default __webpack_public_path__ + "static/media/330_dummy2016-kunstgalerie01-mobile-de.7db9ac88.png";